// extracted by mini-css-extract-plugin
export default {"bar":"PageHeaderBar_bar__JZKJO"};